import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { GLOBALMESSAGES } from '../../../constants/messages';
import './Messages.scss';

interface MessageDialogProps {
    open: boolean;
    onClose: () => void;
    title: React.ReactNode;
    children: React.ReactNode;
    dialogActions?: React.ReactNode;
}

const MessageDialog: React.FC<MessageDialogProps> = ({
    open,
    onClose,
    title,
    children,
    dialogActions,
}) => {
    return (
        <Dialog id="customized-dialog-title" open={open} onClose={(event, reason) => {
            if (reason !== GLOBALMESSAGES.BACKDROP) {
                onClose();
            }
        }} fullWidth
            maxWidth={false}
            sx={{ maxWidth: 800, margin: 'auto' }}>
            <DialogTitle className="msg-dialog-title">
                {title}
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={() => ({
                        position: "absolute",
                        right: 8,
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#fff",
                    })}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent
                dividers
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1.5,
                    maxHeight: 'calc(100vh - 180px)',
                    overflowY: 'auto',
                    minHeight: 300,
                }}
            >
                {children}
            </DialogContent>

            {dialogActions && <DialogActions>{dialogActions}</DialogActions>}
        </Dialog >
    );
};

export default MessageDialog;
